export const deprecatedMsg = 'is going to be deprecated, please consider removing it from your project';
